import React, { Component } from 'react';
import Select2 from 'react-select2-wrapper';
import { reduxForm, Field } from 'redux-form';
import { browserHistory } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import Header from '../../components/Header';
import { onGoBack, sortData } from '../../common/globals';
import withOtherCharge from '../../common/withOtherCharge';
import { getProductChargeType, getTableCaseByCaseId, getVhnPpcValue } from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import OtherChargeTypeModal from '../../components/Models/OtherChargeModal';
import { renderField, requiredAmount } from '../../helpers/form-validations';
import withVhnPpcOtherCharge from '../../common/withVhnPpcOtherCharge';
import withProducts from '../../common/withProducts';
import withTableName from '../../common/withTableName';

class OtherCharge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chargeType: [],
      selectedType: '',
      selectedChargeData: {},
      charge_amount: '',
      addAmount: false
    };
    this.OtherChargeTypeModal = null;
  }

  componentDidMount() {
    try {
      this.OtherChargeTypeModal = new window.bootstrap.Modal(window.$('#otherChargeType'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOtherChargeType = () => {
    try {
      this.OtherChargeTypeModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = async (formData) => {
    try {
      const { selectedType, selectedChargeData } = this.state;
      const {
        setOtherCharge, goBack, setVhnPpcOtherCharge, vhnPpcOtherCharge, params: { id }, tableName,
        setProducts
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      if (selectedType === null || selectedType === '') {
        this._onOtherChargeType();
      } else {
        selectedChargeData.amount = formData.charge_amount;
        setOtherCharge(selectedChargeData);
        setVhnPpcOtherCharge(false);
        if (vhnPpcOtherCharge === true) {
          setProducts(caseDetail.case_products);
          browserHistory.push(`/manage-case/${id}/products/add`);
        } else {
          onGoBack(goBack);
        }
        // onGoBack(goBack);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectChargeType = (value) => {
    try {
      const { chargeType } = this.state;
      const selectedChargeData = chargeType.filter(
        (item) => item.TypeOptionsID.toString() === value
      );
      this.setState({ selectedType: value, selectedChargeData: selectedChargeData[0] });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickAmount = () => {
    try {
      this.setState({ addAmount: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const {
        goBack, setOtherCharge, setVhnPpcOtherCharge, vhnPpcOtherCharge, params: { id }
      } = this.props;
      setOtherCharge({});
      setVhnPpcOtherCharge(false);
      if (vhnPpcOtherCharge === true) {
        browserHistory.push(`/manage-case/${id}/products/add`);
      } else {
        onGoBack(goBack);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setVhnPpcValue = async () => {
    const { chargeType } = this.state;
    const { params: { id }, tableName } = this.props;
    const caseDetail = await getTableCaseByCaseId(id, tableName);
    let vhnPpcValue = {};
    if (caseDetail.CustomerName !== null) {
      // vhnPpcValue = await getVhnPpcValue(caseDetail.CustomerName);
      const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
      if (typeof vhnPpc !== 'undefined') {
        vhnPpcValue = vhnPpc;
      }
    }
    chargeType.map((value) => {
      if (caseDetail.CaseType === 'HIP' && vhnPpcValue.VHN_PPC === '1') {
        if (value.OptionName === 'VELYS HIP NAV TOWER PPC FEE' || value.OptionNo === '099995000') {
          this.setState({
            selectedType: value.TypeOptionsID,
            addAmount: true
          }, () => {
            const selectedChargeData = chargeType.filter(
              (item) => item.TypeOptionsID === this.state.selectedType
            );
            this.setState({ selectedChargeData: selectedChargeData[0], });
          });
        }
        setTimeout(() => {
          window.$('#chargeAmount').focus();
        }, 500);
      }

      if (caseDetail.CaseType === 'KNEE' && vhnPpcValue.VRAS_PPC === '1') {
        if (value.OptionName === 'VELYS PPC USAGE FEE' || value.OptionNo === '451570404') {
          this.setState({
            selectedType: value.TypeOptionsID,
            addAmount: true
          }, () => {
            const selectedChargeData = chargeType.filter(
              (item) => item.TypeOptionsID === this.state.selectedType
            );
            this.setState({ selectedChargeData: selectedChargeData[0], });
          });
        }
        setTimeout(() => {
          window.$('#chargeAmount').focus();
        }, 500);
      }
    });
  }

  async UNSAFE_componentWillMount() {
    try {
      const { vhnPpcOtherCharge } = this.props;
      const chargeType = await getProductChargeType();
      const sortRes = sortData(chargeType, 'OptionName');
      this.setState({ chargeType: sortRes }, () => {
        if (vhnPpcOtherCharge === true) {
          this._setVhnPpcValue();
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const {
      chargeType, selectedType, addAmount
    } = this.state;
    return (
      <section>
        <form onSubmit={handleSubmit(this._onSubmit)} form="OtherChargeForm">
          <Header
            actionButton={{ title: 'Save' }}
            title="Other Charge"
            goBack={this._onGoBack}
          />

          <section className="section">
            <div className="container">
              <div className="row">
                <div className="col-12 mt-3">
                  <div className="case-data">
                    <label htmlFor="type">Charge Type</label>
                    <Select2
                      style={{ width: '100%' }}
                      className="form-control"
                      data={chargeType.map(({ OptionName, TypeOptionsID }) => ({
                        text: OptionName,
                        id: TypeOptionsID
                      }))}
                      onSelect={({ target: { value } }) => {
                        this._onSelectChargeType(value);
                      }}
                      value={selectedType}
                      options={{ placeholder: 'Select Charge Type' }}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="case-data">
                    <label htmlFor="amount">Charge Amount</label>
                    {
                      addAmount
                      && <span className="d-inline-block charge-amount">$</span>
                    }
                    <Field
                      type="number"
                      id="chargeAmount"
                      className="form-control"
                      step="any"
                      name="charge_amount"
                      style={{ paddingLeft: '14px' }}
                      component={renderField}
                      validate={requiredAmount}
                      placeholder="Amount"
                      onFocus={this._onClickAmount}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>
        <OtherChargeTypeModal />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'OtherChargeForm',
});

export default withTableName(withProducts(withVhnPpcOtherCharge(withOtherCharge(withGoBack(withForm(
  withNotify(withLoader(
    OtherCharge
  ))
))))));
